export default __webpack_public_path__ + "static/xpay_landing-8e8d2b0b6f13d7083def3c08d73b4564.png";